import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Truck, ShieldCheck, CreditCard, Headphones, ChevronRight, Star, Instagram, Users, Home as HomeIcon, ShoppingBag } from "lucide-react";
import { getProducts } from "../lib/api";
import { BRAND, waLink, eur } from "../config";
import ProductCard from "../components/ProductCard";
import Reveal from "../components/Reveal";
import { WhatsAppIcon } from "../components/WhatsAppButton";

const HERO = "https://static.prod-images.emergentagent.com/jobs/b62be457-ebdb-4219-8aac-2fecc3b4b298/images/a2ebcebba951e47861c31cff0c67737c55b9996a83bf496124a93f193a95a574.png";
const HERO_MOBILE = "https://static.prod-images.emergentagent.com/jobs/b62be457-ebdb-4219-8aac-2fecc3b4b298/images/b8f10a54583cb2a0ad0c0b6ed1754f2b23457f27904b5e98aec3ec9e9b2444ab.png";

const CATS = [
  { slug: "robes", name: "Robes", img: "https://images.unsplash.com/photo-1771430908710-379a289f9607?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { slug: "tops", name: "Tops & Hauts", img: "https://images.unsplash.com/photo-1601117830731-1a36c879f666?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { slug: "maillots", name: "Maillots de Bain", img: "https://images.unsplash.com/photo-1713433366641-4138ec16c909?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { slug: "lingerie", name: "Lingerie", img: "https://images.unsplash.com/photo-1590955256677-dcd589b027c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { slug: "bijoux", name: "Bijoux", img: "https://images.unsplash.com/photo-1631346543932-ce110c10dbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=700" },
  { slug: "lunettes", name: "Lunettes & Accessoires", img: "https://images.pexels.com/photos/35462327/pexels-photo-35462327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700" },
];

const TRUST = [
  { icon: Truck, label: "Livraison en Guadeloupe" },
  { icon: ShieldCheck, label: "Qualité Sélectionnée" },
  { icon: CreditCard, label: "Paiement Sécurisé" },
  { icon: Headphones, label: "Service Client Disponible" },
];

const COLLECTIONS = [
  { title: "Summer Queen", sub: "Plage & maillots", img: "https://images.unsplash.com/photo-1713433366641-4138ec16c909?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", cat: "maillots" },
  { title: "Soirée Glamour", sub: "Robes & bijoux de soirée", img: "https://images.pexels.com/photos/18731383/pexels-photo-18731383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800", cat: "robes" },
  { title: "Esther Classique", sub: "Les indémodables", img: "https://images.unsplash.com/photo-1771430908710-379a289f9607?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", cat: "all" },
];

const TESTIMONIALS = [
  { name: "Sabrina", commune: "Les Abymes", text: "Livraison ultra rapide et la robe est magnifique ! Je recommande les yeux fermés.", stars: 5 },
  { name: "Murielle", commune: "Le Gosier", text: "Une vraie caverne d'Ali Baba ! Les bijoux dorés sont superbes et ne noircissent pas.", stars: 5 },
  { name: "Laëtitia", commune: "Baie-Mahault", text: "J'ai organisé une soirée shopping avec mes amies, un moment inoubliable. Merci Esther !", stars: 5 },
];

const INSTA = [
  "https://images.unsplash.com/photo-1769650795527-a707e63754a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  "https://images.unsplash.com/photo-1631346543932-ce110c10dbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  "https://images.unsplash.com/photo-1713433366641-4138ec16c909?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  "https://images.pexels.com/photos/35462327/pexels-photo-35462327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500",
  "https://images.unsplash.com/photo-1590955256677-dcd589b027c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  "https://images.unsplash.com/photo-1601117830731-1a36c879f666?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
];

const SectionTitle = ({ overline, title, sub }) => (
  <div className="text-center mb-12">
    {overline && <p className="font-serif-el italic text-dore text-lg mb-1">{overline}</p>}
    <h2 className="font-display text-3xl md:text-5xl text-encre">{title}</h2>
    {sub && <p className="text-ardoise/70 text-sm mt-3 max-w-xl mx-auto">{sub}</p>}
    <div className="gold-line w-24 mx-auto mt-5" />
  </div>
);

export default function Home() {
  const [nouveautes, setNouveautes] = useState([]);
  const [best, setBest] = useState([]);

  useEffect(() => {
    getProducts({ is_new: true, sort: "new" }).then((d) => setNouveautes(d.slice(0, 8))).catch(() => {});
    getProducts({ is_bestseller: true, sort: "bestseller" }).then((d) => setBest(d.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section className="relative h-[85vh] min-h-[520px] flex items-center">
        <img src={HERO_MOBILE} alt="Esther, fondatrice de La Boutique d'Esther en Guadeloupe" className="absolute inset-0 w-full h-full object-cover object-top md:hidden" />
        <img src={HERO} alt="Esther, fondatrice de La Boutique d'Esther en Guadeloupe" className="absolute inset-0 w-full h-full object-cover object-[75%_center] hidden md:block" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20" />
        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl">
            <p className="text-dore font-serif-el italic text-xl md:text-2xl mb-3">Mode & Accessoires Féminins en Guadeloupe</p>
            <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl text-white tracking-wide leading-none">LA BOUTIQUE<br />D'ESTHER</h1>
            <p className="text-white/90 font-serif-el italic text-xl md:text-2xl mt-4">{BRAND.slogan}</p>
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <Link to="/boutique" className="bg-dore text-noir px-8 py-4 text-xs uppercase tracking-widest font-semibold hover:bg-dore/90 transition-colors text-center" data-testid="hero-shop-btn">Découvrir la boutique</Link>
              <a href={waLink()} target="_blank" rel="noreferrer" className="border border-white text-white px-8 py-4 text-xs uppercase tracking-widest font-semibold hover:bg-white hover:text-noir transition-colors text-center flex items-center justify-center gap-2" data-testid="hero-whatsapp-btn"><WhatsAppIcon size={16} /> Commander sur WhatsApp</a>
            </div>
          </div>
        </div>
        <a href="#collections" className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 animate-bounce-down"><ChevronDown size={28} /></a>
      </section>

      {/* Trust */}
      <section className="bg-white border-b border-dore/10">
        <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {TRUST.map((t, i) => (
            <div key={i} className="flex items-center gap-3 justify-center md:justify-start">
              <t.icon size={26} className="text-dore shrink-0" strokeWidth={1.3} />
              <span className="text-xs md:text-sm text-encre">{t.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Intro */}
      <section className="max-w-3xl mx-auto text-center px-6 py-16">
        <Reveal>
          <p className="font-serif-el text-xl md:text-2xl text-ardoise leading-relaxed">Bienvenue à La Boutique d'Esther, votre boutique mode féminine en Guadeloupe. Découvrez notre sélection de robes, bijoux, lunettes, lingerie et maillots de bain, soigneusement choisis pour vous sublimer.</p>
        </Reveal>
      </section>

      {/* Categories */}
      <section id="collections" className="max-w-7xl mx-auto px-6 py-16">
        <Reveal><SectionTitle overline="Découvrez notre sélection mode" title="Nos Collections" /></Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {CATS.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.05}>
              <Link to={`/boutique?category=${c.slug}`} className="group relative block overflow-hidden hover-zoom aspect-[4/5]" data-testid={`category-${c.slug}`}>
                <img src={c.img} alt={c.name} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent group-hover:from-black/80 transition-all" />
                <div className="absolute inset-0 flex items-end p-5">
                  <div>
                    <h3 className="font-display text-xl md:text-2xl text-white">{c.name}</h3>
                    <span className="text-dore text-xs uppercase tracking-widest flex items-center gap-1 mt-1">Découvrir <ChevronRight size={14} /></span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Nouveautés */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <Reveal><SectionTitle overline="Les dernières pièces sélectionnées pour vous" title="Nouveautés" /></Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-x-6 md:gap-y-10">
          {nouveautes.map((p, i) => <Reveal key={p.slug} delay={(i % 4) * 0.05}><ProductCard product={p} /></Reveal>)}
        </div>
        <div className="text-center mt-12">
          <Link to="/nouveautes" className="inline-block border border-dore text-encre px-8 py-3.5 text-xs uppercase tracking-widest font-semibold hover:bg-dore hover:text-white transition-colors">Voir toutes les nouveautés</Link>
        </div>
      </section>

      {/* Promo banner */}
      <section className="relative grain bg-noir py-20 px-6 text-center overflow-hidden">
        <div className="relative max-w-2xl mx-auto">
          <p className="font-display text-3xl md:text-5xl text-dore">Livraison partout en Guadeloupe</p>
          <p className="text-white/70 mt-3 font-serif-el italic text-lg">Frais calculés selon le poids · dès 13€</p>
          <Link to="/boutique" className="inline-block mt-7 bg-dore text-noir px-8 py-4 text-xs uppercase tracking-widest font-semibold hover:bg-dore/90 transition-colors">En profiter maintenant</Link>
        </div>
      </section>

      {/* Collections phares */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <Reveal><SectionTitle title="Collections Phares" /></Reveal>
        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {COLLECTIONS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <Link to={`/boutique?category=${c.cat}`} className="group relative block overflow-hidden hover-zoom aspect-[3/4]">
                <img src={c.img} alt={c.title} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                  <h3 className="font-display text-2xl md:text-3xl text-white">{c.title}</h3>
                  <p className="text-dore font-serif-el italic mt-1">{c.sub}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Best-sellers */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal><SectionTitle overline="Les préférées de nos clientes" title="Nos Best-Sellers" /></Reveal>
          <div className="flex gap-4 md:gap-6 overflow-x-auto no-scrollbar pb-4 snap-x">
            {best.map((p) => (
              <div key={p.slug} className="min-w-[220px] sm:min-w-[260px] snap-start"><ProductCard product={p} /></div>
            ))}
          </div>
        </div>
      </section>

      {/* Ventes privées */}
      <section className="bg-rose/40 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div className="overflow-hidden hover-zoom aspect-[4/5] max-h-[560px]">
              <img src="https://images.pexels.com/photos/18731383/pexels-photo-18731383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900" alt="Soirée shopping" className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-serif-el italic text-dore text-xl">Une expérience unique</p>
            <h2 className="font-display text-3xl md:text-5xl text-encre mt-1">Organisez votre Soirée Shopping</h2>
            <p className="text-ardoise mt-4 leading-relaxed">Invitez vos amies et profitez d'une expérience shopping unique à domicile. Essayez nos robes, bijoux, lingerie et accessoires dans la bonne humeur. <b className="text-encre">Cadeau offert à l'hôtesse !</b></p>
            <div className="space-y-4 mt-6">
              {[{ i: Users, t: "Vous invitez vos amies" }, { i: HomeIcon, t: "Esther vient chez vous" }, { i: ShoppingBag, t: "Vous profitez et commandez" }].map((s, k) => (
                <div key={k} className="flex items-center gap-3">
                  <span className="bg-white rounded-full p-2.5"><s.i size={18} className="text-dore" /></span>
                  <span className="text-encre text-sm">{s.t}</span>
                </div>
              ))}
            </div>
            <Link to="/ventes-privees" className="inline-block mt-8 bg-noir text-white px-8 py-4 text-xs uppercase tracking-widest font-semibold hover:bg-ardoise transition-colors" data-testid="ventes-privees-cta">Organiser ma soirée</Link>
          </Reveal>
        </div>
      </section>

      {/* Testimonials */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <Reveal><SectionTitle title="Ce que disent nos clientes" /></Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="bg-white border border-dore/20 p-7 h-full">
                <div className="flex gap-0.5 mb-3">{Array.from({ length: t.stars }).map((_, k) => <Star key={k} size={16} className="fill-dore text-dore" />)}</div>
                <p className="font-serif-el text-lg text-ardoise italic leading-relaxed">"{t.text}"</p>
                <p className="text-encre font-medium mt-4 text-sm">{t.name}</p>
                <p className="text-ardoise/60 text-xs">{t.commune}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Instagram */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <Reveal><SectionTitle overline={BRAND.instagramHandle} title="Suivez-nous sur Instagram" /></Reveal>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-1">
          {INSTA.map((src, i) => (
            <a key={i} href={BRAND.instagram} target="_blank" rel="noreferrer" className="group relative block overflow-hidden aspect-square">
              <img src={src} alt="Instagram" loading="lazy" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-noir/0 group-hover:bg-noir/40 transition-all flex items-center justify-center">
                <Instagram size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-8">
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-dore text-encre px-8 py-3.5 text-xs uppercase tracking-widest font-semibold hover:bg-dore hover:text-white transition-colors"><Instagram size={16} /> Nous suivre sur Instagram</a>
        </div>
      </section>
    </div>
  );
}
